import { _ } from "libs";

/// <reference types="googlemaps" />
import React, { useState } from "react";
import Dropdown from "../dropdown/dropdown";
import { Location } from "../../types";
import MultiSearchInput from "../multiSearchInput";

function getLocationErrorMessage(code: number): string {
	switch (code) {
		case 1:
			return _("locationError.permissionDenied");
		case 2:
			return _("locationError.positionUnavailable");
		case 3:
			return _("locationError.timeout");
	}

	return "";
}

const LocationOption = ({ location, onClick, value }: { location: Location; onClick; value }) => {
	return (
		<div className="item" onClick={() => (onClick ? onClick(location) : null)}>
			<div className="itemBody">
				<div className="title">{location.placeId === "around_me" ? _(location.name) : location.name}</div>
				<div className="meta">
					{location.errorCode
						? getLocationErrorMessage(location.errorCode)
						: location.playersCount
						? _("club.numberOfPlayers", location.playersCount, {
								numberOfPlayers: location.playersCount,
						  })
						: ""}
				</div>
			</div>
		</div>
	);
};

const AddCity = ({ onSelect }: { onSelect }) => {
	const [open, toggleOpen] = useState(false);

	const [suggestion, setSuggesstion] = useState(null);

	const geocoder = new google.maps.Geocoder();

	const openInput = () => {
		toggleOpen(true);
	};

	const closeInput = () => {
		toggleOpen(false);
	};

	const onCitySelect = () => {
		geocoder.geocode(
			{ address: suggestion.description },
			async (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => {
				if (results[0]) {
					const center = results[0].geometry.location;
					const location = {
						name: suggestion.value,
						lat: center.lat(),
						lng: center.lng(),
						playersCount: 0,
						placeId: results[0].place_id,
					} as Location;
					onSelect(location);
				}
			}
		);
	};

	if (open) {
		return (
			<div className="form addCityToLocationsForm">
				<div className="field searchField searchFieldWithAutosuggest">
					<MultiSearchInput
						onChange={setSuggesstion}
						valueProperty="description"
						placeholder={_("addCityToLocationsForm.inputPlaceholder")}
						types={["place"]}
					/>
				</div>
				<button className="button" onClick={onCitySelect} disabled={suggestion === null}>
					{_("addCityToLocationsForm.addBtn")}
				</button>
				<a className="button outline" onClick={closeInput}>
					{_("addCityToLocationsForm.cancelBtn")}
				</a>
			</div>
		);
	} else {
		return (
			<div onClick={openInput} className="link">
				{_("addCityToLocationsForm.addCity")}
			</div>
		);
	}
};

const LocationDropdown = ({
	onSelect,
	onChange,
	locations,
	selectedLocation,
}: {
	onSelect;
	onChange;
	locations: Location[];
	selectedLocation: Location;
}) => {
	let value = null;
	if (selectedLocation) {
		value = <LocationOption location={selectedLocation} value={selectedLocation} onClick={e => {}} />;
	}

	return (
		<Dropdown
			value={value}
			overrideOnClick={true}
			extraClass="locationDropdown"
			render={({ close }) => {
				return [
					locations.map(location => {
						return (
							<LocationOption
								location={location}
								key={location.placeId}
								value={location}
								onClick={location => {
									onChange(location);
									close();
								}}
							/>
						);
					}),
					<AddCity onSelect={onSelect} />,
				];
			}}
		/>
	);
};

export default LocationDropdown;
